/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Time_MuratInputs */

const tr_landing_community_mock_time_murat = /** @type {(inputs: Landing_Community_Mock_Time_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5dk`)
};

const en_landing_community_mock_time_murat = /** @type {(inputs: Landing_Community_Mock_Time_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5m`)
};

const de_landing_community_mock_time_murat = /** @type {(inputs: Landing_Community_Mock_Time_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Min`)
};

const ru_landing_community_mock_time_murat = /** @type {(inputs: Landing_Community_Mock_Time_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 мин`)
};

/**
* | output |
* | --- |
* | "5m" |
*
* @param {Landing_Community_Mock_Time_MuratInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_time_murat = /** @type {((inputs?: Landing_Community_Mock_Time_MuratInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Time_MuratInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_time_murat(inputs)
	if (locale === "de") return de_landing_community_mock_time_murat(inputs)
	if (locale === "ru") return ru_landing_community_mock_time_murat(inputs)
	return tr_landing_community_mock_time_murat(inputs)
});